import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import './Spiegazione.css';

//IMMAGINI
import settings from "./assets/img/settings.png";
import client_id from "./assets/img/client_id.png";
import token from "./assets/img/token.png";
import ricerca from "./assets/img/ricerca.png";
import Freturn from "./assets/img/return.png";
import risultato1 from "./assets/img/risultato1.png";
import risultato2 from "./assets/img/risultato2.png";

function AlertDismissible() {
  const [show, setShow] = useState(false);

  return (
    <>
      <Alert show={show} variant="success">
        <Alert.Heading>SPIEGAZIONE UTILIZZO API SPOTIFY</Alert.Heading>
        <div className="allineaTesto">
            {/* FUNZIONAMENTO */}
            <font color="yellow">·Funzionamento·</font>
            <br/>Dato il nome di un artista l'applicazione web mostra la foto e alcuni dati, inoltre nei risultati di ricerca inserisce artisti con un genere musicale simile a quello dell'artista cercato.
            <div className='allineaImmagine'><img src={risultato1} width="50%"></img></div>
            <div className='allineaImmagine'><img src={risultato2} width="50%"></img></div>

            {/* Spotify for Developers */}
            <br/><br/><font color="yellow">·Registrazione Spotify for Developers·</font>
            <br/>Come prima cosa, se ancora non è stato fatto, è necessario accedere alla pagina di Spotify for Developers e creare una nuova applicazione cliccando su "create an app"
            <br/><font color="green">App name:</font> nome che vogliamo dare alla nostra applicazione (es. Spotify React)
            <br/><font color="green">App description:</font> descrizione della nostra applicazione
            <br/>A questo punto cliccare su <font color="green">edit settings</font> ed impostare come <font color="green">Redirect URLs: http://localhost:3000</font> infine cliccare su <font color="green">save</font>
            <br/>La dashboard di Spotify for Developers è disponibile <a href='https://developer.spotify.com/dashboard/applications' target={"new"}>QUI</a>.
            <div className='allineaImmagine'><img src={settings} width="30%"></img></div>
            
            {/* Client ID */}
            <font color="yellow">·Client ID·</font>
            <br/>Nel file <font color="green">App.js</font> è necessario andare ad inserire alla riga 14 la costante relativa al nostro client ID, questo codice può essere trovato nella pagina principale dell'applicazione registrata su Spotify precedentemente.
            <div className='allineaImmagine'><img src={client_id} width="50%"></img></div>
        
            {/* Token */}
            <font color="yellow">·Accesso tramite token·</font>
            <br/>L'accesso a questo servizio si basa sull'utilizzo di un gettone (<font color="green">token</font>) che viene settato in uno <font color="green">useState</font> tramite uno <font color="green">useEffect</font>; dal momento in cui decido di effetuare il logout dal mio Account Spotify lo useState viene impostato come strnga vuota e il token viene rimosso dal local storage (<font color="green">removeItem</font>).
            <br/><font color="green">REDIRECT_URI</font> URL con il quale vado a visualizzare la mia app (di default è il localhost sulla porta 3000).
            <br/><font color="green">AUTH_ENDPOINT</font> PAGINA di autenticazione per l'accesso a Spotify.
            <div className='allineaImmagine'><img src={token} width="50%"></img></div>

            {/* Ricerca */}
            <font color="yellow">·Ricerca·</font>
            <br/>Quando vado a scrivere nella casella di testo aggiorno costantemente la <font color="green">searchKey</font> e quando clicco sul button <font color="green">SERACH</font> attraverso una chiamata a funzione esterna (<font color="green">API</font>) vado a cercare l'artista e lo vado ad inserire all'interno dello <font color="green">useState artists</font>, in questo useState non si trova soltanto l'artista ricercato ma anche alcuni artisti con genermi muisicali simili a quello ricercato.
            <br/>Le informazioni degli artisti trovati (insieme alla loro immagine) vengono inserite nei rispettivi &lt;div&gt;, questo procedura avviene per ogni artista salvato nello useState grazie al comando <font color="green">map</font>.
            <div className='allineaImmagine'><img src={ricerca} width="50%"></img></div>

            {/* Return */}
            <font color="yellow">·Return·</font>
            <br/>Nel return come prima cosa viene inserito un titolo e una breve descrizione della web app.
            <br/>Successivamente viene inserito il <font color="green">button per il logout</font> (e il relativo link per il login), sotto di esso, oltre il button per mostarre questa descrizione, troviamo la <font color="green">casella di input</font> per la ricerca dell'artista e il <font color="green">button SEARCH</font>.
            <br/>Sotto a questi button veranno mostrati i risulati della ricerca <font color="green">mostraArtista()</font>.
            <br/>Ultimo particolare la scritta <font color="green">È NECESSARIO EFFETUARE IL LOGIN</font> che viene mostrata quando non è presente un token (prima di un login/dopo aver effettuato un logout).
            <div className='allineaImmagine'><img src={Freturn} width="50%"></img></div>
        </div>
        <div className="d-flex justify-content-center">
          <Button className='buttonChiudi' onClick={() => setShow(false)}>Chiudi</Button>
        </div>
      </Alert>

      {!show && <Button className='buttonMostra' onClick={() => setShow(true)}>Mostra spiegazione</Button>}
    </>
  );
}

export default AlertDismissible;